import request from '@/router/axios'

export const shareFileInfo = (params) => {
  return request({
    method: 'get',
    url: `/api/share/fileinfov2`,
    params: params
  })
}

export const getBanType = () => {
  return request({
    method: 'post',
    url: `/v1/usersharefilesbantype/index`,
    data: {}
  })
}
export const submitBan = (data) => {
  return request({
    method: 'post',
    url: `/v1/usersharefilesban/submitv2`,
    data
  })
}

export const getCdnSignature = (data) => {
  return request({
    method: 'post',
    url: `/v2/cdn/generate_url`,
    data
  })
}

export const postShaerFile = (data) => {
  return request({
    method: 'post',
    url: `/v1/cloudfile/share_add`,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sharefiles.js